import $ from 'jquery';
import 'slick-carousel';
import 'magnific-popup';
import Combobo from 'combobo';
import { CountUp } from 'countup.js';
import ScrollMagic from 'scrollmagic';
import iframeResize from 'iframe-resizer/js/iframeResizer';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js';
import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import 'jquery-lazy/jquery.lazy.min';
import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar.min';

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

const lodashThrottle = require('lodash/throttle');

const $win = $(window);
const $body = $('body');
const $sidebars = $('.js-sticky-sidebar');

// sticky sidebar start
$sidebars.each((index, elem) => $(elem).attr('data-id', `sticky-${index}`));
let stickySidebars = [];
function initSticky() {
    if ($sidebars.length === 0 || window.innerWidth < 768) {
        return;
    }
    $sidebars.each(function (index, elem) {
        const $elem = $(elem);
        if ($elem.find('.section__item').length <= 3 || isIe() || isEdge()) {
            return;
        }

        stickySidebars[index] = new StickySidebar(`[data-id="${$elem.attr('data-id')}"] .section__content`, {
            containerSelector: `[data-id="${$elem.attr('data-id')}"] .shell`,
            innerWrapperSelector: `[data-id="${$elem.attr('data-id')}"] .section__inner`,
            resizeSensor: true,
            topSpacing: 200,
        });
    });
}
function reinitSticky() {
    let timeout;
    $win.resize(function () {
        clearTimeout(timeout);
        timeout = setTimeout(function () {
            if (window.innerWidth < 768 && stickySidebars.length > 0) {
                stickySidebars.forEach(sidebar => sidebar.destroy());
                stickySidebars = [];
            } else if (window.innerWidth > 1025 && stickySidebars.length === 0) {
                initSticky();
            }
        }, 400);
    });
}
$win.on('load', function () {
    setTimeout(function () {
        initSticky();
    }, 1000);
});
reinitSticky();
// sticky sidebar end

window.$app.doingAjax = false;

sliderInit();
tabs();
stickyHeader();
comboboInit();
setMobileNavHeight();
initScrollMagic();
popupVideo();
bgVideoPause();
hideBar();
navClick();
hideDropdown();
helpTrigger();
accordion();
animateNumbers();
mobileDropdowns();
navTrigger();
prepareConsultantFilters();
prepareResourceTopicSelector();
prepareResourceFilters();
prepareGlossaryFilters();
prepareGlossaryPopups();
prepareSearchPage();
prepareFAQOverview();
formStates();
formTerms();
formLinks();
prepareLockedTabs();
focusElements();
scrollToId();
imageFit();
pardotIframeHeight();
calcXMLIframeHeight();
resourceHeroBackLink();
clearSearch();
superscriptSpecialChars();

$win.on('load', function () {
    $('.intro__image-video video').responsiveVideo();

    if ($('.intro--home').length) {
        $body.addClass('home-loaded');

        if (!$('.section-preloader').length) {
            $body.addClass('home-loaded--forced');
        } else {
            setCookie('home-preloader-shown', 1, 0);
        }
    } else {
        $body.addClass('page-loaded');

        setTimeout(function () {
            $body.addClass('page-loaded-secondary');
        }, 500); // fix loader position after loadin animation

        setTimeout(function () {
            $body.addClass('page-loaded-tertiary');
        }, 1500); // remove delays
    }

    popupGuide();

    setTimeout(function () {
        popupNewsletter();
    }, 3000); // load after longest preloader

    reveal();

    if ($('.section-callouts-vertical').length) {
        mobileWidthVerticalCallouts();
    }

    $('.section-resources .section__item:not(.section__item--large)').equalizeHeight();

    lazyLoadImages();
});

$win.on('scroll', function () {
    reveal();
});

$win.on('resize', function () {
    $('.section-resources .section__item:not(.section__item--large)').equalizeHeight();
    loadDesktopImages();
    loadMobileImages();
});

function lazyLoadImages() {
    $('[data-src]').Lazy();

    loadDesktopImages();
    loadMobileImages();
}

function loadDesktopImages() {
    if ($win.width() >= 768) {
        $('img[data-desktop-src]').each(function (index, element) {
            element.src = element.getAttribute('data-desktop-src');
            element.removeAttribute('data-desktop-src');
        });

        $('[data-desktop-src]').each(function (index, element) {
            element.style.backgroundImage = `url(${element.getAttribute('data-desktop-src')})`;
            element.removeAttribute('data-desktop-src');
        });
    }
}

function loadMobileImages() {
    if ($win.width() < 768) {
        $('img[data-mobile-src]').each(function (index, element) {
            element.src = element.getAttribute('data-mobile-src');
            element.removeAttribute('data-mobile-src');
        });

        $('[data-mobile-src]').each(function (index, element) {
            element.style.backgroundImage = `url(${element.getAttribute('data-mobile-src')})`;
            element.removeAttribute('data-mobile-src');
        });
    }
}

function sliderInit() {
    let phone = false;
    if ($win.width() < 768) { // if mobile
        phone = true;
    }

    const $slider = $('.js-slider');
    $slider.slick({
        dots: true,
        arrows: false,
        infinite: true,
        vertical: !phone,
        verticalSwiping: !phone,
        accessibility: true,
        customPaging(slider, i) {
            const slideNumber = (i + 1);
            const totalSlides = slider.slideCount;
            return `<a 
            href="#" 
            class="button" 
            role="tab" 
            id="slick-slide-control0${slideNumber - 1}" 
            aria-controls="slick-slide0${slideNumber - 1}" 
            aria-label="${slideNumber} of ${totalSlides}" 
            tabindex="0">${slideNumber}</a>`;
        },
    }).on('afterChange', function () {
        $win.scroll();
    });

    $('.slick-dots .button').on('keyup', function (e) {
        if ((e.keyCode === 32) || (e.keyCode === 13)) {
            $(this).click();
        }
        e.preventDefault();
    }).on('click', function (e) {
        e.preventDefault();
    });
}

function tabs() {
    if ($('.section-sidemenu .section__nav button[aria-selected="true"]').length) {
        const $this = $('.section-sidemenu .section__nav button[aria-selected="true"]');
        arrowPosition($this);
    }

    $('.section-sidemenu .section__nav button, .section-callouts-nav button').on('click', function () {
        const $this = $(this);
        let $searchContainer = $this.parents('.shell');

        if ($searchContainer.parents('.section-callouts-tabs').length) {
            $searchContainer = $searchContainer.parents('.section-callouts-tabs');
        }

        $this.attr('aria-selected', 'true').siblings().attr('aria-selected', 'false');

        const $panel = $searchContainer.find(`#${$this.attr('aria-controls')}`);
        const $parent = $panel.parent();

        $panel.addClass('is-current')
            .siblings()
            .removeClass('is-current');

        $parent.css({ minHeight: `${$panel.height()}px` });

        if ($this.parents('.section__nav-inner').length) {
            arrowPosition($this);
        }
    });
}

function arrowPosition($button) {
    const top = $button.position().top + $button.outerHeight() / 2;
    $button.parents('.section__nav-inner')
        .find('.section__nav-arrow')
        .css('top', `${top}px`);
}

$.fn.equalizeHeight = function () {
    let maxHeight = 0;
    let itemHeight;

    for (let i = 0; i < this.length; i += 1) {
        $(this[i]).height('');
        itemHeight = $(this[i]).height();
        if (maxHeight < itemHeight) {
            maxHeight = itemHeight;
        }
    }

    return this.height(maxHeight);
};

function popupVideo() {
    $('.js-popup-video').magnificPopup({
        type: 'iframe',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close Popup (Esc)">&#215;</button>',
    });
}

function popupNewsletter() {
    const $popup = $('#newsletter-popup');
    if ($popup.length < 1) {
        return;
    }

    let popupViews = parseInt(getCookie($popup.data('cookie')), 10);
    if (Number.isNaN(popupViews)) {
        popupViews = 0;
    }

    setTimeout(function () {
        if (!$body.hasClass('no-scroll')) {
            $.magnificPopup.open({
                items: {
                    src: '#newsletter-popup',
                },
                type: 'inline',
                callbacks: {
                    beforeOpen() {
                        $(this.contentContainer).addClass('newsletter-popup');
                        $(this.bgOverlay).addClass('mfp-bg--transparent');
                    },
                },
                closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close Popup (Esc)">&#215;</button>',
            }, 0);
        }

        setCookie($popup.data('cookie'), popupViews + 1, 365);
    }, $popup.data('delay') * 1000);
}

function popupGuide() {
    const $popup = $('#guide-popup');
    if ($popup.length < 1) {
        return;
    }

    $('.js-guide-popup').magnificPopup({
        items: {
            src: '#guide-popup',
        },
        type: 'inline',
        callbacks: {
            beforeOpen() {
                $(this.contentContainer).addClass('newsletter-popup');
            },
        },
        closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close Popup (Esc)">&#215;</button>',
    });
}

function popupDescription(content) {
    $.magnificPopup.open({
        items: {
            src: $(`<div class="section-popup section-popup--text">${content}</div>`),
        },
        type: 'inline',
        closeMarkup: '<button title="%title%" type="button" class="mfp-close" aria-label="Close Popup (Esc)">&#215;</button>',
    });
}

function bgVideoPause() {
    $('.intro__image-play').on('click', function (e) {
        const $trigger = $(this);
        const $videoContainer = $trigger.parent().prev('.intro__image-video');
        const video = $videoContainer.find('video')[0];

        if ($videoContainer.hasClass('paused')) {
            video.play();
            $videoContainer.removeClass('paused');
            $trigger.attr('aria-label', 'Pause Video');
        } else {
            video.pause();
            $videoContainer.addClass('paused');
            $trigger.attr('aria-label', 'Play Video');
        }
        e.preventDefault();
    });
}

$.fn.responsiveVideo = function () {
    const resizeRepsonsiveVideo = function () {
        const $player = $(this);

        const winWidth = $player.parent().width();
        const winHeight = $player.parent().height();

        const imgDimensionsRatio = $player.attr('height') / $player.attr('width');

        if (winHeight / winWidth > imgDimensionsRatio) {
            $player.height(winHeight).width(winHeight / imgDimensionsRatio);
        } else {
            $player.width(winWidth).height(winWidth * imgDimensionsRatio);
        }
    };

    const videos = this;
    $win.on('resize', function () {
        videos.each(resizeRepsonsiveVideo);
    });

    return videos.each(resizeRepsonsiveVideo);
};

function hideBar() {
    $('.js-bar-close').on('click', function (e) {
        e.preventDefault();
        $('.bar').addClass('bar--hidden');
        setCookie('banner', '1', 0);
    });
}

function helpTrigger() {
    $('.footer__trigger').on('click', function (e) {
        $(this).parent().toggleClass('is-active');
        e.preventDefault();
    });
}

function animateNumbers() {
    $('.countUp').each(function () {
        const el = $(this);
        const winH = $win.outerHeight();
        const number = el.data('number');
        const options = {
            useEasing: true,
            useGrouping: true,
            decimalPlaces: el.data('decimalplaces'),
            separator: '',
            decimal: el.data('decimal'),
        };

        const countUp = new CountUp(el[0], number, options);

        $win.on('scroll', function () {
            if (el.offset().top + el.outerHeight() <= $win.scrollTop() + winH) {
                if (!el.hasClass('animated')) {
                    countUp.start();
                    el.addClass('animated');
                }
            }
        });
    });
}

function accordion() {
    $('.accordion__trigger').on('click', function () {
        const $this = $(this);

        if ($this.attr('aria-expanded') === 'true') {
            $this.attr('aria-expanded', 'false');
        } else {
            $this.attr('aria-expanded', 'true');
        }

        const target = $this.attr('aria-controls');

        $this.siblings(`.accordion__body[id="${target}"]`).slideToggle()
            .siblings('.accordion__body')
            .slideUp()
            .parent()
            .siblings('.accordion__section')
            .find('.accordion__trigger')
            .attr('aria-expanded', 'false')
            .next()
            .slideUp();
    });
}

function navClick() {
    $('.header a').on('click', function (e) {
        const $this = $(this);
        if (!$this.parent().hasClass('has-children') && $win.width() > 767 && !$this.is('[target]')) {
            e.preventDefault();
            $body.addClass('page-exit');

            setTimeout(function () {
                window.location.href = $this.attr('href');
            }, 700); // animation duration
        }
    });

    $('.nav .has-children > a').on('click', openDropdownMenu);
    $('.nav .has-children > a').on('keyup', dropdownKeyupHandler);
    $('.nav .has-children > a').on('keydown', dropdownKeydownHandler);

    $('.nav-dropdown .nav__col ul a').on('keydown', function (e) {
        const $this = $(this);
        const isInLastCol = $this.parents('.nav__col').is(':last-child');
        const isLastItem = $this.parent().next().length;

        if ((e.keyCode === 9 && isLastItem === 0 && isInLastCol) || e.keyCode === 27) { // tab or esc pressed
            $this.parents('.nav-dropdown').attr('aria-expanded', 'false')
                .prev()
                .removeClass('is-active');
        }
    });
}

function openDropdownMenu(e) {
    e.preventDefault();
    const $dropdown = $(this).next('.nav-dropdown');

    if ($dropdown.attr('aria-expanded') === 'true') {
        $dropdown.attr('aria-expanded', 'false');
        $dropdown.prev().removeClass('is-active');
    } else {
        $dropdown.attr('aria-expanded', 'true');
        $dropdown.prev().addClass('is-active');
    }

    $dropdown.parent()
        .siblings('.has-children')
        .find('.nav-dropdown')
        .attr('aria-expanded', 'false')
        .prev()
        .removeClass('is-active');
}

// If spacebar or enter is pressed, open the dropdown
function dropdownKeydownHandler(e) {
    if (e.keyCode === 32 || e.keyCode === 13) {
        e.preventDefault();
        this.click();
    }
}

// If the spacebar is pressed, don't scroll the page
function dropdownKeyupHandler(e) {
    if (e.keyCode === 32) {
        e.preventDefault();
    }
}

function hideDropdown() {
    $(document).mouseup(function (e) {
        const dropdownParent = $('.nav .has-children');

        if (!dropdownParent.is(e.target) && dropdownParent.has(e.target).length === 0) {
            dropdownParent
                .find('.nav-dropdown')
                .attr('aria-expanded', 'false')
                .prev().removeClass('is-active');
        }
    });
}

function mobileDropdowns() {
    $('.nav-mobile .has-children > a').on('click', function (e) {
        const $this = $(this);

        if (!$this.next('span').length) {
            e.preventDefault();

            $this.next('ul').slideToggle();
        }
    });

    $('.nav-mobile .has-children > span').on('click', function () {
        $(this).toggleClass('is-active')
            .next()
            .slideToggle()
            .parent()
            .siblings()
            .find('span')
            .removeClass('is-active')
            .next()
            .slideUp();
    });
}

function navTrigger() {
    $('.nav-trigger').on('click', function (e) {
        $(this).toggleClass('is-active');
        const $navMobile = $('.nav-mobile');
        const noScrollClass = 'no-scroll';

        if ($navMobile.attr('aria-expanded') === 'true') {
            $navMobile.attr('aria-expanded', 'false');
        } else {
            $navMobile.attr('aria-expanded', 'true');
        }

        if ($body.hasClass(noScrollClass)) {
            $('body, html').removeClass(noScrollClass);
        } else {
            $('body, html').addClass(noScrollClass);
        }

        e.preventDefault();
    });
}

function reveal() {
    $('.reveal').each(function () {
        const el = $(this);
        const winH = $win.outerHeight();

        if (el.offset().top <= $win.scrollTop() + 0.8 * winH) {
            if (!el.hasClass('visible')) {
                el.addClass('visible');
            }
        }
    });
}

function mobileWidthVerticalCallouts() {
    const $wrapper = $('.section-callouts-vertical .section__items');
    const width = 23.5 * $wrapper.children().length + 4;
    if ($win.width() < 767) {
        $wrapper.css('width', `${width}rem`);
    } else {
        $wrapper.removeAttr('width');
    }
}

function prepareConsultantFilters() {
    const $consultantListing = $('#consultant-listing');
    if ($consultantListing.length < 1) {
        return;
    }

    $win.on('load', function () {
        $consultantListing.find('.reveal').addClass('visible');
    });

    $('#field-state').change(() => setTimeout(filterConsultants, 10));
    $('#field-topic').change(() => setTimeout(filterConsultants, 10));
    $('[data-specialty]').click(function (event) {
        event.preventDefault();
        $(this).parent().siblings().removeClass('is-current')
            .end()
            .addClass('is-current');
        $('#field-topic').val(this.dataset.specialty);
        filterConsultants();
    });

    // handle pre-filtered pages
    filterConsultants(true);

    if (isIe()) {
        Object.values = function (obj) {
            return Object.keys(obj).map(function (e) {
                return obj[e];
            });
        };
    }
}

function filterConsultants(initialCall = false) {
    const selectedState = $('#field-state').val();
    const selectedSpecialty = $('#field-topic').val();
    const $consultants = $('#consultant-listing .section__member');

    $consultants.each(function (index, elem) {
        const states = JSON.parse(elem.dataset.states);
        const specialties = JSON.parse(elem.dataset.specialties);

        if
        (
            (
                selectedState == null || Object.values(states).indexOf(selectedState) >= 0
            ) && (
                selectedSpecialty == null || Object.values(specialties).indexOf(selectedSpecialty) >= 0
            )
        ) {
            elem.style.display = '';
        } else {
            elem.style.display = 'none';
        }
    });

    if ($consultants.filter('[style*="display"]').length === $consultants.length) {
        $('#consultant-listing .js-not-found').show();
    } else {
        $('#consultant-listing .js-not-found').hide();
    }

    if (initialCall === false) {
        let newLocation = `${window.location.origin}${window.location.pathname}`;

        if (selectedState) {
            newLocation = `${newLocation}?state=${selectedState}`;
            if (selectedSpecialty) {
                newLocation = `${newLocation}&specialty=${selectedSpecialty}`;
            }
        } else if (selectedSpecialty) {
            newLocation = `${newLocation}?specialty=${selectedSpecialty}`;
        }

        window.history.replaceState(
            null,
            null,
            newLocation,
        );
    }
}

function prepareResourceTopicSelector() {
    $('.section-topic button').click(function () {
        window.location = $(this).closest('.section__inner').find('.option.selected').attr('value');
    });
}

function prepareResourceFilters() {
    if ($('#filterable-resources').length < 1) {
        return;
    }

    $win.on('load', function () {
        $('#filterable-resources .reveal').addClass('visible');
    });

    $('#field-resource-topic').change(function () {
        let newLocation = `${window.location.origin}${window.location.pathname}`;
        const searchTerm = $('#field-resource-search').val();

        if (this.value) {
            newLocation = `${newLocation}?topic=${this.value}`;
            if (searchTerm) {
                newLocation = `${newLocation}&term=${searchTerm}`;
            }
        } else if (searchTerm) {
            newLocation = `${newLocation}?term=${searchTerm}`;
        }

        getResourcesAjax(1);
        window.history.replaceState(
            null,
            null,
            newLocation,
        );
    });
    prepareReplacedResourceFilters();
    prepareLoadMore();

    $('.form-search form').submit(function (event) {
        event.preventDefault();
        getResourcesAjax();

        let newLocation = `${window.location.origin}${window.location.pathname}`;
        const searchTerm = $('#field-resource-search').val();
        const type = $('#field-resource-type').val();

        if (type) {
            newLocation = `${newLocation}?type=${type}`;
            if ($('#field-resource-topic option').length !== 1 && $('#field-resource-topic').val()) {
                newLocation = `${newLocation}&topic=${$('#field-resource-topic').val()}`;
            }
            if (searchTerm) {
                newLocation = `${newLocation}&term=${searchTerm}`;
            }
        } else if ($('#field-resource-topic option').length !== 1 && $('#field-resource-topic').val()) {
            newLocation = `${newLocation}?topic=${$('#field-resource-topic').val()}`;
            if (searchTerm) {
                newLocation = `${newLocation}&term=${searchTerm}`;
            }
        } else if (searchTerm) {
            newLocation = `${newLocation}?term=${searchTerm}`;
        }

        window.history.replaceState(
            null,
            null,
            newLocation,
        );
    });
}

function prepareReplacedResourceFilters() {
    $('#field-resource-type').change(function () {
        let newLocation = `${window.location.origin}${window.location.pathname}`;
        const searchTerm = $('#field-resource-search').val();

        if (this.value) {
            newLocation = `${newLocation}?type=${this.value}`;
            if ($('#field-resource-topic option').length !== 1 && $('#field-resource-topic').val()) {
                newLocation = `${newLocation}&topic=${$('#field-resource-topic').val()}`;
            }
            if (searchTerm) {
                newLocation = `${newLocation}&term=${searchTerm}`;
            }
        } else if ($('#field-resource-topic option').length !== 1 && $('#field-resource-topic').val()) {
            newLocation = `${newLocation}?topic=${$('#field-resource-topic').val()}`;
            if (searchTerm) {
                newLocation = `${newLocation}&term=${searchTerm}`;
            }
        } else if (searchTerm) {
            newLocation = `${newLocation}?term=${searchTerm}`;
        }

        window.history.replaceState(
            null,
            null,
            newLocation,
        );
        getResourcesAjax();
    });

    $('#filterable-resources .section__filter a').click(function (event) {
        event.preventDefault();
    });

    $('#filterable-resources .section__filter li:not(.is-current) a').click(function () {
        $(this)
            .parent()
            .siblings()
            .removeClass('is-current')
            .end()
            .addClass('is-current');

        $('#field-resource-type').val(this.attributes.href.value);

        let newLocation = `${window.location.origin}${window.location.pathname}`;
        const searchTerm = $('#field-resource-search').val();

        if (this.attributes.href.value !== 'all') {
            newLocation = `${newLocation}?type=${this.attributes.href.value}`;
            if ($('#field-resource-topic option').length !== 1 && $('#field-resource-topic').val()) {
                newLocation = `${newLocation}&topic=${$('#field-resource-topic').val()}`;
            }
            if (searchTerm) {
                newLocation = `${newLocation}&term=${searchTerm}`;
            }
        } else if ($('#field-resource-topic option').length !== 1 && $('#field-resource-topic').val()) {
            newLocation = `${newLocation}?topic=${$('#field-resource-topic').val()}`;
            if (searchTerm) {
                newLocation = `${newLocation}&term=${searchTerm}`;
            }
        } else if (searchTerm) {
            newLocation = `${newLocation}?term=${searchTerm}`;
        }

        window.history.replaceState(
            null,
            null,
            newLocation,
        );

        getResourcesAjax();
    });
}

function prepareLoadMore() {
    $('#filterable-resources .js-load-more').click(function (event) {
        event.preventDefault();

        getResourcesAjax(
            0,
            $('#filterable-resources .section__item:not(.section__item--large)').length,
            parseInt(this.dataset.limit, 10),
            1,
        );
    });
}

function getResourcesAjax(newTopic = 0, offset = 0, limit = 10, loadMore = 0) {
    if (window.$app.doingAjax) {
        return;
    }
    window.$app.doingAjax = true;

    const $resources = $('#filterable-resources');
    const $overlay = $resources.find('.js-overlay');
    const selectedType = $('#field-resource-type').val();
    const data = {};

    data[window.$app.csrfTokenName] = window.$app.csrfTokenValue;
    data.topic = $('#field-resource-topic').val();
    data.type = newTopic ? '' : selectedType;
    data.topicChange = newTopic;
    data.offset = offset;
    data.limit = limit;
    data.loadMore = loadMore;
    data.subheading = $resources.find('.section__head h2').text();
    data.searchTerm = $('#field-resource-search').val();

    if (
        (
            !selectedType || selectedType === 'all'
        ) && (
            $('#field-resource-topic option').length === 1 || !data.topic
        ) && (
            !data.searchTerm
        )
    ) {
        data.featuredResourceId = $resources.data('featured');
    }

    if (loadMore) {
        $resources.find('.section__actions i').fadeIn();
    } else {
        $overlay.fadeIn();
    }

    $.ajax({
        url: $resources.data('action'),
        dataType: 'JSON',
        type: 'POST',
        data,
    }).done(function (response) {
        if (!Object.prototype.hasOwnProperty.call(response, 'markup')) {
            ajaxFailureAlert();
            return;
        }

        if (loadMore) {
            const resourceCount = $resources.find('.section__item').length;
            $resources.find('.section__items').append(response.markup.replace(/data-src/g, 'src'));
            if (response.showLoadMore) {
                $resources.find('.section__actions i').fadeOut();
            } else {
                $resources.find('.section__actions').remove();
            }
            $resources.find('.section__item').eq(resourceCount)
                .find('.section-resource').focus();
        } else {
            $resources.find('.shell').replaceWith($(`<div>${response.markup.replace(/data-src/g, 'src')}</div>`).find('.shell'));
            $overlay.fadeOut();
            prepareReplacedResourceFilters();
            prepareLoadMore();
        }

        setTimeout(function () {
            $resources.find('.reveal').addClass('visible');
            imageFit();
        }, 400);

        window.$app.doingAjax = false;
    }).fail(function () {
        ajaxFailureAlert();
    });
}

function filterGlossary($glossary, letter) {
    $glossary
        .find('.section__item')
        .hide()
        .filter(`[data-letter="${letter}"]`)
        .show();

    $glossary
        .find('ul li')
        .removeClass('is-current');

    $glossary
        .find(`a[href="${letter}"]`)
        .parent()
        .addClass('is-current');

    if ($glossary.find(`[data-letter="${letter}"]`).length === 0) {
        $glossary.find('.section__items')
            .prepend(`<div class="section__item js-no-results">No words starting with ${letter} found.</div>`);
    } else {
        $glossary.find('.js-no-results').remove();
    }
}

function prepareGlossaryFilters() {
    const $glossary = $('.section-glossary');
    if ($glossary.length < 1) {
        return;
    }

    const $select = $glossary.find('#field-glossary');

    $glossary.find('ul li a').click(function (event) {
        event.preventDefault();

        $select.val(this.attributes.href.value);

        filterGlossary($glossary, this.attributes.href.value);
    });

    $select.change(function () {
        filterGlossary($glossary, this.value);
    });
}

function prepareGlossaryPopups() {
    const $glossary = $('.section-glossary');
    if ($glossary.length < 1) {
        return;
    }

    $glossary.find('a[data-description]').click(function (event) {
        event.preventDefault();

        popupDescription(this.dataset.description);
    });
}

function prepareSearchPage() {
    if ($('form[action$="actions/resources/default/search"]').length === 0) {
        return;
    }

    $('.intro #field-search').focus();

    $('#form-search form').submit(function (event) {
        event.preventDefault();

        let newLocation = `${window.location.origin}${window.location.pathname}`;

        if ($('#field-resource-type').val()) {
            newLocation = `${newLocation}?type=${$('#field-resource-type').val()}`;
            if ($('#field-search').val()) {
                newLocation = `${newLocation}&term=${$('#field-search').val()}`;
            }
        } else if ($('#field-search').val()) {
            newLocation = `${newLocation}?term=${$('#field-search').val()}`;
        }

        window.history.replaceState(
            null,
            null,
            newLocation,
        );
        getSearchResultsAjax();
    });

    prepareReplacedSearchPageFilters();
}

function prepareReplacedSearchPageFilters() {
    $('#field-resource-type').change(function () {
        getSearchResultsAjax();

        let newLocation = `${window.location.origin}${window.location.pathname}`;

        if (this.value) {
            newLocation = `${newLocation}?type=${this.value}`;
            if ($('#field-search').val()) {
                newLocation = `${newLocation}&term=${$('#field-search').val()}`;
            }
        } else if ($('#field-search').val()) {
            newLocation = `${newLocation}?term=${$('#field-search').val()}`;
        }

        window.history.replaceState(
            null,
            null,
            newLocation,
        );
    });

    $('#search-results .section__filter a').click(function (event) {
        event.preventDefault();
    });

    $('#search-results .section__filter li:not(.is-current) a').click(function () {
        $(this)
            .parent()
            .siblings()
            .removeClass('is-current')
            .end()
            .addClass('is-current');

        $('#field-resource-type').val(this.attributes.href.value);

        let newLocation = `${window.location.origin}${window.location.pathname}`;

        if (this.attributes.href.value === 'all' && $('#field-search').val()) {
            newLocation = `${newLocation}?term=${$('#field-search').val()}`;
        } else {
            newLocation = `${newLocation}?type=${this.attributes.href.value}`;
            if ($('#field-search').val()) {
                newLocation = `${newLocation}&term=${$('#field-search').val()}`;
            }
        }

        window.history.replaceState(
            null,
            null,
            newLocation,
        );

        getSearchResultsAjax();
    });

    $('#search-results .section__paging a').click(function (event) {
        event.preventDefault();

        if (this.dataset.current != null) {
            return;
        }

        const currentPage = parseInt($('#search-results').data('page'), 10);
        const pageCount = parseInt($('#search-results').data('pages'), 10);
        let newPage = 1;

        if (this.attributes.href.value === 'prev') {
            if (currentPage === 1) {
                return;
            }
            newPage = currentPage - 1;
        } else if (this.attributes.href.value === 'next') {
            if (currentPage === pageCount) {
                return;
            }
            newPage = currentPage + 1;
        } else if (this.attributes.href.value === currentPage) {
            return;
        } else {
            newPage = this.attributes.href.value;
        }

        getSearchResultsAjax(newPage);
    });
}

function getSearchResultsAjax(currentPage = null) {
    if (window.$app.doingAjax) {
        return;
    }
    window.$app.doingAjax = true;

    const $searchForm = $('.form-search form');
    const $searchResults = $('#search-results');
    const $overlay = $searchResults.find('.js-overlay');
    const $pageSpinner = $searchResults.find('.section__paging .fa-spinner');
    const data = {};

    data[window.$app.csrfTokenName] = window.$app.csrfTokenValue;
    data.currentPage = currentPage == null ? $searchResults.data('page') : currentPage;
    data.typeHandle = $('#field-resource-type').val();
    data.searchTerm = $('#field-search').val();

    $overlay.fadeIn();
    $pageSpinner.fadeIn();

    $.ajax({
        url: $searchForm[0].action,
        dataType: 'JSON',
        type: 'POST',
        data,
    }).done(function (response) {
        if (!Object.prototype.hasOwnProperty.call(response, 'markup')) {
            ajaxFailureAlert();
            return;
        }

        $('#search-message').replaceWith(response.markup.replace(/data-src/g, 'src'));
        $searchResults.replaceWith(response.markup.replace(/data-src/g, 'src'));
        imageFit();
        $overlay.fadeOut();
        $pageSpinner.fadeOut();

        window.$app.doingAjax = false;
        prepareReplacedSearchPageFilters();

        if (currentPage) {
            $([document.documentElement, document.body]).animate({
                scrollTop: $('#search-results').offset().top,
            }, 800);
        }
    }).fail(function () {
        ajaxFailureAlert();
    });
}

function prepareFAQOverview() {
    const $form = $('#faq-overview');

    $form.parents('.intro--small').addClass('intro--faq');

    if ($form.length < 1) {
        return;
    }

    // handle predefined filter from URL parameters
    if ($form.find('select').val()) {
        $('.section-faq').hide().filter(`[data-topic="${$form.find('select').val()}"]`).show();
    }

    $form.submit(function (event) {
        event.preventDefault();
    });

    $form.find('select').change(function () {
        if (this.value) {
            $('.section-faq').hide().filter(`[data-topic="${this.value}"]`).show();
            window.history.replaceState(
                null,
                null,
                `${window.location.origin}${window.location.pathname}?topic=${this.value}`,
            );
            $win.scroll();
        } else {
            $('.section-faq').show();
            window.history.replaceState(null, null, `${window.location.origin}${window.location.pathname}`);
        }
    });
}

// Cookie helpers
function getCookie(name) {
    const v = document.cookie.match(`(^|;) ?${name}=([^;]*)(;|$)`);
    return v ? v[2] : null;
}

function setCookie(name, value, days) {
    if (days === 0) {
        document.cookie = `${name}=${value};path=/;`;
        return;
    }
    const d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = `${name}=${value};path=/;expires=${d.toUTCString()};samesite=strict`;
}


function formStates() {
    $('.form--states form').on('submit', function (e) {
        const $form = $(this);
        const state = $form.find('select[name="field-state"]').val();

        const arr = ['AL', 'AZ', 'AR', 'CA', 'GA', 'ID', 'IN', 'IA', 'KS', 'KY', 'MO', 'OK', 'PA', 'SD', 'TN'];
        if (arr.indexOf(state) > -1) {
            clickNextTab($form, true);
        } else if (state === 'OH') {
            if ($form.parents('.section__entry').length) {
                $form.parents('.section__entry').removeClass('is-current')
                    .siblings('#error-ohaio-tab').addClass('is-current')
                    .parent()
                    .prev()
                    .find('button[id="review-terms"]')
                    .attr('aria-disabled', true)
                    .attr('disabled', true);
            } else { // mobile accordion
                $form.parents('.accordion__body').slideUp()
                    .siblings('#sect1-error')
                    .slideDown()
                    .parent()
                    .next()
                    .find('.accordion__trigger')
                    .attr('aria-disabled', true)
                    .attr('disabled', true);
            }
        } else if (state === 'WA') {
            if ($form.find('input[id^=field-yes]').is(':checked')) {
                clickNextTab($form, true);
            } else if ($form.parents('.section__entry').length) {
                $form.parents('.section__entry').removeClass('is-current')
                    .siblings('#error-washington-tab').addClass('is-current')
                    .parent()
                    .prev()
                    .find('button[id="review-terms"]')
                    .attr('aria-disabled', true)
                    .attr('disabled', true);
            } else { // mobile accordion
                $form.parents('.accordion__body').slideUp()
                    .siblings('#sect1-error-2')
                    .slideDown()
                    .parent()
                    .next()
                    .find('.accordion__trigger')
                    .attr('aria-disabled', true)
                    .attr('disabled', true);
            }
        } else {
            clickNextTab($form, false);
        }
        e.preventDefault();
    });

    $('.form--states select[name="field-state"]').on('change', function () {
        const $state = $(this);

        if ($state.val() === 'WA') {
            $state.parents('.form__row').next().slideDown({
                complete() {
                    $(this).attr('aria-disabled', 'false').attr('disabled', true);
                },
            });
        } else {
            $state.parents('.form__row').next().slideUp({
                complete() {
                    $(this).attr('aria-disabled', 'true').attr('disabled', true);
                },
            });
        }
    });
}

function formTerms() {
    $('.form--terms form').on('submit', function (e) {
        const $form = $(this);
        clickNextTab($form, false);
        e.preventDefault();
    });

    $('.form--terms input').on('change', function () {
        const $checkbox = $(this);

        $checkbox
            .closest('.checkbox')
            .find('.section__warning')
            .remove();

        // require file download before proceeding to next step
        if ($checkbox.is('[data-download="true"]') === false) {
            $checkbox
                .closest('.checkbox')
                .append('<div class="section__warning">Download and review the Offering Circular to continue.</div class="section__warning">');

            return;
        }

        $checkbox.parents('.form__body')
            .next()
            .find('.form__btn')
            .attr('aria-disabled', !$checkbox.is(':checked'))
            .attr('disabled', !$checkbox.is(':checked'));
    });


    // register file download to allow proceeding to next step
    $(document).on('click', 'a.btn.btn--term-download', function () {
        const $checkbox = $(this).next().find('.field-terms');

        $checkbox
            .attr('data-download', 'true')
            .parents('.form__body')
            .next()
            .find('.form__btn')
            .attr('aria-disabled', !$checkbox.is(':checked'))
            .attr('disabled', !$checkbox.is(':checked'));

        $checkbox
            .closest('.checkbox')
            .find('.section__warning')
            .remove();
    });
}

function formLinks() {
    const $sideMenu = $('.section-sidemenu .section__nav');

    $('.form--links form').on('submit', function (e) {
        const $form = $(this);
        const values = $form.serializeArray();
        let targetEnd = 'acc';
        let $parent = $('.section-sidemenu .accordion');
        let buttonId = 'accordion4id';

        if ($form.parents('.section__entry').length) {
            targetEnd = 'tab';
            $parent = $sideMenu;
            buttonId = 'complete-your-paperwork';
        }

        let target = `${values[0].value}-${values[1].value}-${targetEnd}`;

        if (values[0].value === 'sep-ira') {
            target = `${values[0].value}-${targetEnd}`;
        }

        $parent.find(`button[id="${buttonId}"]`)
            .attr('aria-controls', target);

        if ($sideMenu.outerHeight() < $(`#${target}`).outerHeight()) {
            $sideMenu.css('height', $(`#${target}`).outerHeight());
        }

        clickNextTab($form, false);
        e.preventDefault();
    });

    $('.btn--next').on('click', function (e) {
        clickNextTab($(this), false);
        e.preventDefault();
    });
}

function clickNextTab($el, isInArray) {
    let $terms = $('input[name="field-terms"]');
    let $elParent;
    let parentId = '#sect1';

    if ($el.parents('.section__entry').length) {
        $elParent = $el.parents('.section__entry');
        parentId = '#select-your-state-tab';

        $(`#${$elParent.attr('aria-labelledby')}`).attr('aria-selected', 'false')
            .next()
            .attr('aria-disabled', 'false')
            .attr('disabled', false)
            .click();
    } else {
        $elParent = $el.parents('.accordion__body');

        $elParent.slideUp()
            .prev()
            .attr('aria-expanded', 'false')
            .parent()
            .next()
            .find('.accordion__trigger')
            .attr('aria-disabled', 'false')
            .attr('disabled', false)
            .click();
    }

    if (isInArray === true) {
        $terms = $('input[name="field-terms-state"]');
    }

    if ($elParent.is(parentId)) {
        $terms.parents('li')
            .attr('aria-disabled', 'false')
            .attr('disabled', false)
            .siblings()
            .attr('aria-disabled', 'true')
            .attr('disabled', true); // Change checkbox in next step
    }
}

function ajaxFailureAlert() {
    window.alert('An error occurred. Please try reloading the page.'); // eslint-disable-line no-alert
}

function setMobileNavHeight() {
    $win.on('load resize', () => {
        $('.nav-mobile').css('height', $win.innerHeight());
    });
}

function comboboInit() {
    if ($('.combobox').length) {
        const combobo = new Combobo();

        combobo.on('selection', function () {
            $(combobo.currentOption).siblings('.option').removeClass('selected');
        });
    }
}

function initScrollMagic() {
    // init controller
    const controller = new ScrollMagic.Controller();

    // parallax
    $('[data-parallax]').each((i, elem) => {
        const triggerElement = $(elem).closest('.shell')[0];
        let offset = -$(triggerElement).height();

        if (typeof $(elem).data('offset') !== 'undefined') {
            offset = $(elem).data('offset');
        }

        const duration = $(triggerElement).height() + $win.outerHeight();

        // build scene
        new ScrollMagic.Scene({ triggerElement, duration, offset })
            .setTween(elem, { transform: `translateY(${elem.dataset.parallax})` })
            .addTo(controller); // .addIndicators();
    });
}

function isIe() {
    return window.navigator.userAgent.indexOf('Trident/') > 0;
}

function isEdge() {
    return window.navigator.userAgent.indexOf('Edge/') > 0;
}

function imageFit() {
    if (isIe()) {
        $('.js-image-fit').each((i, container) => {
            const $container = $(container);
            const $image = $container.find('img');
            const imageSource = $image.attr('src') || $image.data('src');

            $container.css('background-image', `url(${imageSource})`);
            $image.addClass('sr-only');
        });
    }
}

function stickyHeader() {
    const $header = $('.header');
    const fixedClass = 'is-fixed';
    const visibleClass = 'is-visible';
    let lastScrollTop = null;

    $win.on('load scroll', lodashThrottle(() => {
        const currentScrollTop = $win.scrollTop();

        const scrollBelowHeader = currentScrollTop > $header.outerHeight();

        $header.toggleClass(fixedClass, scrollBelowHeader);

        const scrollUp = currentScrollTop < lastScrollTop;

        $header.toggleClass(visibleClass, scrollUp);

        lastScrollTop = currentScrollTop;
    }, 100));
}


function prepareLockedTabs() {
    const $sections = $('.section-sidemenu');
    if ($sections.length === 0) {
        return;
    }

    $sections.each(function (index, el) {
        const $section = $(el);
        const $checkbox = $section.find('input[type="checkbox"]');
        if ($checkbox.length === 0) {
            return;
        }
        const $accordion = $section.find('.accordion');
        const $accordionCheckbox = $accordion.find('input[type="checkbox"]');

        $section
            .find('button[role="tab"][data-has-checkbox]')
            .nextAll()
            .attr('aria-disabled', 'true')
            .attr('disabled', true);

        $accordion
            .find('.accordion__section[data-has-checkbox]')
            .nextAll()
            .find('.accordion__trigger')
            .attr('aria-disabled', 'true')
            .attr('disabled', true);

        $checkbox.add($accordionCheckbox).change(function () {
            $section
                .find(`a[data-checkbox="${this.id}"]`)
                .attr('aria-disabled', !this.checked)
                .attr('disabled', !this.checked)
                .attr('tabindex', this.checked ? '0' : '-1');

            $accordion
                .find(`a[data-checkbox="${this.id}-accordion"]`)
                .attr('aria-disabled', !this.checked)
                .attr('disabled', !this.checked)
                .attr('tabindex', this.checked ? '0' : '-1');
        });

        $section.find('a[data-checkbox]').click(function (event) {
            event.preventDefault();
            $section
                .find(`button[role="tab"][id="${
                    this.dataset.checkbox.replace('-checkbox-accordion', '').replace('-checkbox', '')
                }"]`)
                .next()
                .attr('aria-disabled', 'false')
                .attr('disabled', false)
                .click()
                .nextUntil('button[data-has-checkbox] + button')
                .attr('aria-disabled', 'false')
                .attr('disabled', false);

            $accordion
                .find(`button[data-section-pair="${
                    this.dataset.checkbox.replace('-checkbox-accordion', '').replace('-checkbox', '')
                }"]`)
                .click()
                .parent()
                .next()
                .find('.accordion__trigger')
                .attr('aria-disabled', 'false')
                .attr('disabled', false)
                .click()
                .parent()
                .nextUntil('.accordion__section[data-has-checkbox] + .accordion__section')
                .find('.accordion__trigger')
                .attr('aria-disabled', 'false')
                .attr('disabled', false);
        });
    });
}

function focusElements() {
    let prevEl = false;

    $(document).on('keyup', function (e) {
        const code = e.keyCode || e.which;
        const $target = $(e.target);

        if (code === 9) { // tab key pressed
            if (prevEl && $target.parents('.footer__popup').length === 0) {
                $('.footer__popup').removeClass('is-active');
            }

            if ($target.parents('.footer__popup').length) {
                prevEl = true;
            } else {
                prevEl = false;
            }
        }
    });
}

function scrollToId() {
    $('.scroll-link').on('click', function (e) {
        const target = $(this).attr('href').split('#')[1];

        if ($(`#${target}`).length) {
            $('body, html').animate({
                scrollTop: $(`#${target}`).offset().top,
            }, 1000);
            e.preventDefault();
        }
    });

    $win.on('load', function () {
        if (window.location.hash) {
            $('body, html').animate({
                scrollTop: $(window.location.hash).offset().top,
            }, 1000);
        }
    });
}

function pardotIframeHeight() {
    window.addEventListener('message', function (e) {
        const iframe = document.getElementById('pardotform');
        const iframe1 = document.querySelector('.section-code iframe');
        const iframe2 = document.querySelector('.intro__consultant-form iframe');
        const iframe3 = document.getElementById('pform');
        const eventName = e.data[0];
        const data = e.data[1];

        if (eventName === 'setHeight' && iframe != null) {
            iframe.height = `${data + 10}px`;
        } else if (eventName === 'setHeight1' && iframe1 != null) {
            iframe1.height = `${data + 10}px`;
        } else if (eventName === 'setHeight1' && iframe2 != null) {
            iframe2.height = `${data + 10}px`;
        } else if (eventName === 'setHeight1' && iframe3 != null) {
            iframe3.height = `${data + 10}px`;
        }
    }, false);
}

function calcXMLIframeHeight() {
    const options = {
        heightCalculationMethod: 'lowestElement',
        inPageLinks: true,
        initCallback: (iFrame) => {
            iFrame.iFrameResizer.moveToAnchor('results');
        },
    };
    iframeResize(options, 'iframe[src*="calcxml.com"]');
}

function resourceHeroBackLink() {
    $('.intro__image-inner .intro__image-back').click(function (event) {
        if (document.referrer.includes(window.location.origin)) {
            event.preventDefault();
            window.history.back();
        }
    });
}

function clearSearch() {
    // show/hide clear btn
    $('.form-search input[type="text"]').on('input', function () {
        const $this = $(this);
        const $clearBtn = $this.closest('.form-search').find('.js-clear-search');

        if ($this.val()) {
            $clearBtn.show();
            $this.css('paddingRight', '10rem');
        } else {
            $clearBtn.hide();
            $this.css('paddingRight', '');
        }
    }).trigger('input');

    // clear btn functionality
    $('.form-search .js-clear-search').on('click', function () {
        $(this)
            .hide()
            .closest('.form__controls')
            .find('input[type="text"]')
            .val('')
            .css('paddingRight', '')
            .closest('form')
            .submit();
    });
}

function superscriptSpecialChars() {
    $('body *:contains("®"):not(:has(*))').each(function (index, elem) {
        const $elem = $(elem);

        $elem.html($elem.text().replace(/®/gi, '<sup>®</sup>'));
    });
}
